import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ===== FULL ANTI-COPY PROTECTION =====
// Right-click disable
document.addEventListener('contextmenu', (e) => e.preventDefault());

// Text selection disable
document.addEventListener('selectstart', (e) => e.preventDefault());

// Keyboard shortcuts disable (Ctrl+C, Ctrl+U, Ctrl+S, Ctrl+Shift+I, F12)
document.addEventListener('keydown', (e) => {
  if (e.ctrlKey && (e.key === 'c' || e.key === 'C' || e.key === 'u' || e.key === 'U' || e.key === 's' || e.key === 'S' || e.key === 'a' || e.key === 'A')) {
    e.preventDefault();
  }
  if (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'i' || e.key === 'J' || e.key === 'j' || e.key === 'C' || e.key === 'c')) {
    e.preventDefault();
  }
  if (e.key === 'F12') {
    e.preventDefault();
  }
});

// Drag disable
document.addEventListener('dragstart', (e) => e.preventDefault());

// DevTools detection
(function() {
  const threshold = 160;
  const check = setInterval(() => {
    if (window.outerWidth - window.innerWidth > threshold || window.outerHeight - window.innerHeight > threshold) {
      document.title = 'Protected Content';
    }
  }, 1000);
  return () => clearInterval(check);
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
